import { DataDRequest } from "../../../data/DRequest";
import { Entidad } from "../../../data/Entidad";
import _L from "../../../util/Labels";
import { UIUtilLang } from "../../util/Language";
import { UIUtilPermission } from "../../util/Permission";
import { Modal } from "../Modal";
import { NotificacionV2 } from "../NotificacionV2";

import CModulo = Entidad.CModulo
import CAccionPermiso = Entidad.CAccionPermiso

export namespace ModalThingsUtil {

    export interface IModalThings<TExtras = any> extends IModalThingsV2<TExtras> {
        readonly BtnLeft: IModalButton;
        readonly BtnRight: IModalButton;
    }

    export interface IModalThingsV2<TExtras = any> {
        Progress: TSelectionHTML<"wc-progress">;
        Modal: Modal;
        CurrentBody: d3.Selection<HTMLDivElement, any, any, any>;
        Extras?: TExtras;
    }

    export interface IModalThingsBase1 {
        Title: string;
        /** @default "aceptar_cancelar" */
        StrModalBotons?: TStrToModalBotons;
        Width?: NonNullable<number>;

        /**
         * * Requerido para verificar permisos
         * * Auxiliar para obtener lang context en thisConfig.LangModuleKeyInContext
        */
        Modulo?: CModulo;
        /** Requerido para verificar permisos */
        Action?: CAccionPermiso;
        IdsEscuelas?: number[];

        /** @default config.Modulo != null ? CModulo[config.Modulo] : null
         * @deprecated remover implementación (usar `_L(...args)`)
        */
        LangModuleKeyInContext?: string;
    }

    export type TStrToModalBotons = "aceptar_cancelar" | "sí_no";

    export interface IModalButton extends TSelectionHTML<"button"> {
        /** @deprecated use {@link IModalButton._Enable} function instead */
        fn_Enable(): IModalButton;
        /** @deprecated use {@link IModalButton._Enable} function instead */
        fn_Disable(): IModalButton;
        _Enable(enable: boolean): IModalButton;
    }

    export interface IResponseItemData<TData> extends DataDRequest.IRequestResponseA<any> {
        ItemData: TData;
    }

    // ****************************************************************
    // LANG CONTEXT
    // ****************************************************************

    interface ILangContext {
        readonly ModuleKeyInContext: string;
        readonly StringTag: string;
    }
    export function GetLangContext(moduleKeyInContext: string, stringKey: string, module?: CModulo, action?: CAccionPermiso): ILangContext {
        moduleKeyInContext = (moduleKeyInContext || CModulo[module]);
        let stringTag = stringKey;

        if (moduleKeyInContext && (!stringKey || !stringKey.includes(" "))) {
            if (!stringKey) {
                if (action && CAccionPermiso[action] != null) {
                    stringTag = UIUtilLang._GetUIString("c_actions", CAccionPermiso[action] as any);
                }
            } else {
                if (CAccionPermiso[stringKey] != null) {
                    stringTag = UIUtilLang._GetUIString("c_actions", stringKey as any);
                } else {
                    stringTag = (UIUtilLang._GetUIString(moduleKeyInContext, stringKey) || stringTag);
                }
            }
        }

        return {
            ModuleKeyInContext: moduleKeyInContext,
            StringTag: stringTag
        }
    }

    export function AjustaTextoBotonesModal(modalThings: IModalThings, typeStrModalBotons: TStrToModalBotons = "aceptar_cancelar") {
        if (typeStrModalBotons == "sí_no") {
            modalThings.BtnLeft.text(_L("general.niega"));
            modalThings.BtnRight.text(_L("general.afirma"));
        }
    }

    // ****************************************************************
    // PERMISSIONS THINGS
    // ****************************************************************

    export function ActionPermission(action: CAccionPermiso, modulo: CModulo, idsEscuelas?: number[]): boolean {
        let hasPermission = true;
        let permissionMessage: string;

        if (action && modulo) {
            if (idsEscuelas?.length > 0) {
                let permissionRes = UIUtilPermission._HasActionsPermissionFromManySchools(action, modulo, idsEscuelas);
                hasPermission = permissionRes.HasPermission;
                permissionMessage = permissionRes.Message;
            } else {
                hasPermission = UIUtilPermission._HasAccionPermission(action, modulo);
            }
        }

        if (!hasPermission) {
            NotificacionV2._Mostrar((permissionMessage || UIUtilLang._GetUIString("permission", "accionparaescuelas")), "ADVERTENCIA");
        }

        return hasPermission;
    }
}